// extracted by mini-css-extract-plugin
export default {"info-text":"bggdgE","infoText":"bggdgE","newInfoUi":"LCjeiB"};